import { GlobalFooter } from "@/patterns/global-footer/src/index";
import JiraSoftwareNavV2 from "@/templates/jira-product-tour-overview/src/sections/productionized/software-jira-navbar";
import JSWFeaturesPageReportsAndInsights from "@/templates/jira-software-features-page/src/sections/reports-and-insights";
import Timeline from "@/templates/jira-software-features-page/src/sections/timeline";

import { JSWFeaturesPageBanner } from "./sections/banner";
import CTASection from "./sections/cta";
import DevOpsSection from "./sections/dev-ops";
import DragAndDropSection from "./sections/drag-and-drop";
import FeaturesSection from "./sections/features";
import HeroSectionControl from "./sections/hero";
import ProjectFlexibilitySection from "./sections/project-flexibility";
import ScrumKanbanBoardSection from "./sections/scrum-kanban-board";
import { SecurityScaleSection } from "./sections/security-scale";
import SocialProof from "./sections/social-proof";

export const JiraSoftwareFeaturesPageTemplate = () => {
    return (
        <div>
            <JiraSoftwareNavV2 />
            {/* Features Page content */}
            <JSWFeaturesPageBanner />
            <HeroSectionControl />
            <Timeline />
            <ScrumKanbanBoardSection />
            <JSWFeaturesPageReportsAndInsights />
            <ProjectFlexibilitySection />
            <DragAndDropSection />
            <FeaturesSection />
            <DevOpsSection />
            <SecurityScaleSection />
            <SocialProof />
            <CTASection />
            <GlobalFooter />
        </div>
    );
};
